import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { ConsumerAICopilot } from './ConsumerAICopilot';
import { isMarketingPublicPath } from './marketing/marketingStandaloneNav';

/**
 * Mounts Atlas (TENSION Atlas Pro) for all consumer-shell routes when nav is visible.
 * Context follows the current path so suggestions stay relevant.
 */
export function ConsumerAICopilotGlobal() {
  const location = useLocation();
  const shouldHideCopilot = useMemo(() => {
    const p = location.pathname;
    // High-focus flows where a floating assistant competes with primary actions.
    return (
      isMarketingPublicPath(p) ||
      p.startsWith('/check-in') ||
      p.startsWith('/quick-check-in') ||
      p.startsWith('/action') ||
      p.startsWith('/notifications') ||
      p.startsWith('/battle')
    );
  }, [location.pathname]);
  const context = useMemo(() => {
    const p = location.pathname;
    if (p.startsWith('/settings')) return 'settings' as const;
    if (p.startsWith('/support')) return 'support' as const;
    if (p === '/home' || p === '/') return 'home' as const;
    return 'app' as const;
  }, [location.pathname]);

  if (shouldHideCopilot) return null;

  return <ConsumerAICopilot context={context} />;
}
